// extracted by mini-css-extract-plugin
export default {"contacts":"ContactCard_contacts__zLncN","profileImg":"ContactCard_profileImg__NImKc"};